// order of imports is important. This file is disabled for prettier import sorting.
import "./utils/infra/initMetadata";
import "./utils/infra/initHistory";
import "./utils/infra/initPackages";
import "./utils/infra/initProviders";
import { init as initProductionLogging } from "@claroty/utilities/productionDebugUtils";
import { setGlobalStore } from "@claroty/utilities/store/store";
import "@claroty/utilities/types/globals";
import { createRoot } from "react-dom/client";
import { initStore } from "./store/initStore";
import { APP_DIV } from "./const/preAuthConsts";
import { initSentryLogging } from "./utils/tracking/sentry/sentry";
import Root from "./components/Root";
import { patchGoogleTranslateCrash } from "./patchGoogleTranslateCrash";
import "@claroty/utilities/types/css.d";

const store = initStore();
setGlobalStore(store);

initProductionLogging();
initSentryLogging();
patchGoogleTranslateCrash();

const root = createRoot(APP_DIV!);
root.render(<Root store={store} /> as any);
